import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreatePodcastFromUrlMutation = createMutationHook(
  MembershipsSpotifyIntegrationsApiClient.createPodcastFromUrl,
  {
    mutationKey: ['createPodcastFromUrl'],
  },
)
